//utils意为：工具类
export default {
  //查找DOM的父级元素，好像没被用到
  findParentNode(node, parent) {
    if (node == parent) {
      return false
    }
    //这什么循环写法，看不懂，估计用了会爆炸吧
    for (var i = 0, n; n = node.parentNode; i++) {
      if (n == parent) {
        return true
      }
      if (n == document.documentElement) {
        return false
      }
    }
  },
  //字符串加星号，前面保留位数，后面保留位数
  plusXing(str, frontLen, endLen) {
    if (str == null) {
      return str
    } else {
      var len = str.length - frontLen - endLen;
      var xing = '';
      for (var i = 0; i < len; i++) {
        xing += '*';
      }
      if (str.length == 2) {
        let a = str[0]
        return a + '*'
      }
      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    }
  },
  //自动识别是返回恰当的域名，供下载url拼接
  returnUrlHead(add) {
    let href = window.location.href
    let yuming = href.split('https://')[1].split('/')[0]
    return add ? `https://${yuming}/${add}` : `https://${yuming}/`
  },
  //空值返回true，有值返回false，区别0
  bool(x) {
    if (!x) {
      if (x === 0) {
        return false
      } else {
        return true
      }
    } else {
      return false
    }
  },
  //把date对象转换成2017-02-02
  dateTrans(date) {
    let str = date.getFullYear() + "-"
    let month = date.getMonth() + 1
    str += (month > 9 ? month : ('0' + month)) + "-"
    let day = date.getDate()
    str += (day > 9 ? day : ('0' + day))
    return str
  },

  //notify自用，接收res或者err.response或者写死的文字。or可以不传
  //用之前，先看下之前以上3种情况都是怎么写的
  myNotify(_this, type, normal, or) {
    if (!normal) {
      //没有normal不弹窗（忘了写，或者err的数据被拦截住了，目前只有403状态会在main.js里被拦截）
    } else {
      let type2
      switch (type) {
        case 'warning':
          type2 = '提示'
          break;
        case 'success':
          type2 = '成功'
          break;
        case 'error':
          type2 = '错误'
      }
      if (or && normal) {
        if (normal.data && normal.data.message) {
          or = normal.data.message
        } else if (normal.message) {
          or = normal.message
        }
      } else {
        or = normal
      }
      _this.$notify({
        title: type2,
        message: or,
        type: type,
      })
    }
  },
  compareDate(date1, date2) {
    date1 = date1.replace(/\-/gi, "/");
    date2 = date2.replace(/\-/gi, "/");
    var time1 = new Date(date1).getTime();
    var time2 = new Date(date2).getTime();
    if (time1 > time2) {
      return false;
    } else if (time1 == time2) {
      return true;
    } else {
      return true;
    }
  },
  currentDate() {
    var nowDate = new Date();
    var year = nowDate.getFullYear();
    var month = nowDate.getMonth() + 1 < 10 ? "0" + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1;
    var day = nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
    var dateStr = year + "-" + month + "-" + day;
    return dateStr;
  }
}



// WEBPACK FOOTER //
// ./src/common/js/util.js